//
// N.B.: Don't try to import this from a lazily-loaded file, because
// __TERMLY_*__ constants are only defined in the primary file returned by
// `/resource-blocker/:uuid/tcf-gvl`
//

export default ( typeof __TERMLY_CLIENT_INFO__ === 'undefined' ) ? void 0 : __TERMLY_CLIENT_INFO__

